import React from "react";
import { PinkQoutesIcon, PinkArabicQoutesIcon } from "../../../public/Theme";
import ImageAtom from "../../Atoms/ImageAtom/ImageAtom";
import ClientsReview from "../../Atoms/Typography/ClientsReview";
import ClientInstagramText from "../../Atoms/Typography/ClientInstagramText";
import {
    CARD_CONTAINER_CLASS,
    IMAGE_CONTAINER_CLASS,
    IMAGE_STYLE,
    INNER_CONTAINER_CLASS,
    qoutesAligmentClass,
    QOUTES_ICON_CLASS,
} from "./constants";
import { ENGLISH } from "../../../public/Constants/EnumConstants";

const TestimonialCard = ({
    description,
    image,
    language,
    index,
    instagram,
}) => {
    return (
        <div key={index} className={CARD_CONTAINER_CLASS}>
            <div className={IMAGE_CONTAINER_CLASS}>
                <ImageAtom image={image} style={IMAGE_STYLE} />

                <div className={INNER_CONTAINER_CLASS}>
                    <ClientInstagramText
                        text={instagram}
                        alignment={language}
                    />
                </div>
            </div>
            <div>
                <img
                    src={
                        language === ENGLISH
                            ? PinkQoutesIcon
                            : PinkArabicQoutesIcon
                    }
                    className={qoutesAligmentClass(language)}
                    alt={"Qoutes Icon"}
                    id={"Qoutes Icon"}
                    loading="lazy"
                />
                <ClientsReview text={description} />
            </div>
        </div>
    );
};

export default TestimonialCard;
